// extracted by mini-css-extract-plugin
export default {"sizable":"Size_sizable__PF4R3","inline":"Size_inline__UHjkb","in-view":"Size_in-view__o6UPf"};